/** Trigger a URL download without Safari treating it as a blocked pop-up. */
export const downloadFromUrl = (url: string) => {
  const link = document.createElement('a')
  link.href = url
  link.click()
  link.remove()
}
